module.exports = __webpack_public_path__ + "static/media/glucosupport1.5f895002.pdf";